import { Reducer } from 'redux';
import { LotsState, LotsTypes } from './types';

const INITIAL_STATE: LotsState = {
  lotData: {
    id: '',
    name: '',
    value: 0,
    startDate: '',
    endDate: '',
    transportOperatorId: '',
  },
  lotsList: [],
  totalCount: 0,
  error: false,
  loading: false,
};

const reducer: Reducer<LotsState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES LIST_LOTS
    case LotsTypes.LIST_LOTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        lotsList: INITIAL_STATE.lotsList,
      };
    case LotsTypes.LIST_LOTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        lotsList: action.payload.lotsList,
        totalCount: action.payload.totalCount,
      };
    case LotsTypes.LIST_LOTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        lotsList: INITIAL_STATE.lotsList,
      };

    // CASES GET LOT
    case LotsTypes.GET_LOT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        lotData: INITIAL_STATE.lotData,
      };
    case LotsTypes.GET_LOT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        lotData: action.payload.lotData,
      };
    case LotsTypes.GET_LOT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        lotData: INITIAL_STATE.lotData,
      };

    // CASES FILTER_LOTS
    case LotsTypes.FILTER_LOTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        lotsList: INITIAL_STATE.lotsList,
      };
    case LotsTypes.FILTER_LOTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        lotsList: action.payload.lotsList,
        totalCount: action.payload.totalCount,
      };
    case LotsTypes.FILTER_LOTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        lotsList: INITIAL_STATE.lotsList,
      };

    // CASES CREATE LOT
    case LotsTypes.CREATE_LOT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        lotData: INITIAL_STATE.lotData,
      };
    case LotsTypes.CREATE_LOT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        lotData: action.payload.lotData,
      };
    case LotsTypes.CREATE_LOT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        lotData: INITIAL_STATE.lotData,
      };

    // CASES UPDATE LOT
    case LotsTypes.UPDATE_LOT_REQUEST:
      return { ...state, loading: true, error: false };
    case LotsTypes.UPDATE_LOT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        lotData: action.payload.lotData,
      };
    case LotsTypes.UPDATE_LOT_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES DELETE LOT
    case LotsTypes.DELETE_LOT_REQUEST:
      return { ...state, loading: true, error: false };
    case LotsTypes.DELETE_LOT_SUCCESS:
      return { ...state, loading: false, error: false };
    case LotsTypes.DELETE_LOT_FAILURE:
      return { ...state, loading: false, error: true };
    default:
      return state;
  }
};

export default reducer;
